import React, { Suspense, lazy } from 'react';
import { Router } from '@reach/router';
import { useSelector } from 'react-redux';

// Components
import Loader from 'components/_utility/Loader/Loader';
import Init from 'components/_utility/Init/Init';
import DummyHeader from 'components/_utility/DummyHeader/DummyHeader';
import { ScrollToTop } from 'components/_utility/ScrollToTop';
import { Wrap } from './App.styled';
import ErrorBoundary from './ErrorBoundary';
import { getErrorSelector } from './redux/app/selectors';

// Lazy import components
const Genres = lazy(() => import('components/_pages/Genres/Genres'));
const Families = lazy(() => import('components/_pages/Families/Families'));
const Bikes = lazy(() => import('components/_pages/Bikes/Bikes'));
const Configurator = lazy(() => import('components/_pages/Configurator/Configurator'));
const Garage = lazy(() => import('components/_pages/Garage/Garage'));

const App = ({ contentApiEndpoint, basepath }) => {
  const error = useSelector(getErrorSelector);

  return (
    <Wrap>
      <ErrorBoundary error={error}>
        <Init contentApiEndpoint={contentApiEndpoint} basepath={basepath}>
          {process.env.MODE === 'development' ? <DummyHeader /> : null}
          <Suspense fallback={<Loader />}>
            <Router basepath={basepath}>
              <ScrollToTop path="/">
                <Genres path="/" />
                <Families path="/families/:genreId" />
                <Genres path="/genres" />
                <Bikes path="/genres/:genre" />
                <Bikes path="/bikes" />
                <Bikes path="/bikes/family/:familyId" />
                <Configurator path="/bike/:bikeId/configure" />
                <Garage path="/garage" />
              </ScrollToTop>
            </Router>
          </Suspense>
        </Init>
      </ErrorBoundary>
    </Wrap>
  );
};

export default App;
